/**
 * Route for `postback-as-api-endpoint`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PostbackAsApiEndpointPage } from "../features/postback-as-api-endpoint/PostbackAsApiEndpointPage";

export const postbackAsApiEndpointRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/postback-as-api-endpoint",
	component: PostbackAsApiEndpointPage,
});

export default postbackAsApiEndpointRoute;
